<template>
  <div class="container">
    <div class="top_title">最新活动</div>
    <div class="read_items" style="overflow-y: auto;margin-top: 2.6rem">
      <router-link v-for="item,index in dataList" tag="div"
                   class="item" :to="{name: 'H040030', params:{id: item.I_ACTIVITY_NO_SYS}}" :key="item.id">
        <div class="left_part">
          <img :src="item.I_ACTIVITY_ICON" />
        </div>
        <div class="right_part">
          <p class="title">{{item.I_TITLE}}</p>
          <div class="remark">
            <span class="icon_school" v-for="school in item.schoolList">{{school.I_SCHOOL_NAME}}</span>
          </div>
          <p class="date"><span class="icon_date"></span>{{item.I_DATE_TIME_DES}}</p>
        </div>
        <span class="icon_activity_state" :class="{ Deadline: item.I_STATUS == '报名截止' }"></span>
        <span class="icon_activity_state" :class="{End: item.I_STATUS == '已结束'}"></span>
        <span class="icon_activity_state" :class="{Giveup: item.I_STATUS == '未参加'}"></span>
        <span class="icon_activity_state" :class="{Signup: item.I_STATUS == '去报名'}"></span>
        <span class="icon_activity_state" :class="{Participated: item.I_STATUS == '已参加'}"></span>
        <span class="icon_activity_state" :class="{Registered: item.I_STATUS == '已报名'}"></span>
      </router-link>
    </div>

    <!--底部导航-->
    <Footer :navs="nav"></Footer>
  </div>
</template>

<script>
  import DataRequestFactory from '@/factories/dataRequestFactory.js'
  import Footer from '../components/Footer.vue'
  import weui from 'weui.js'

  export default {
    name: '',
    data () {
      return {
        nav: {
          sy: false,
          jchd: true,
          yyst: false,
          wd: false,
        },
        tabFlag: false,
        dataList: []
      }
    },
    components: {
      Footer
    },
    created() {
      DataRequestFactory.I040010().then((response) => {
        this.dataList = response.dataList
    })
    },
    mounted() {
      let screenHeight = window.innerHeight;
      let fontSize = getComputedStyle(window.document.documentElement)['font-size']
      let heightDiff = screenHeight - parseInt(fontSize) * 6
      $(".read_items").css("height", heightDiff + "px"   )
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/css/pages/H040020.css';
  @import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H040010.vue